import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { WINDOW } from '@slidebean/hydra/web-apis';
import * as i1 from '@slidebean/hydra/media';

class Animator {
    constructor(media, window) {
        this.media = media;
        this.window = window;
    }
    /**
     * Animates an element using keyframes.
     * @param element Element to be animated
     * @param descriptor animation descriptor containing the keyframes and options
     * @returns A promise that resolves when the animation is complete or gets canceled.
     */
    async animate(element, descriptor) {
        return new Promise(resolve => {
            const duration = this.prefersReducedMotion()
                ? 0
                : descriptor.options?.duration;
            const animation = element.animate(descriptor.keyframes, {
                ...descriptor.options,
                duration,
            });
            animation.addEventListener('cancel', resolve, { once: true });
            animation.addEventListener('finish', resolve, { once: true });
        });
    }
    /**
     * Stops all active animation on the provided element.
     * @param element Element which animations will be canceled.
     * @returns A promise that resolves after all animations are canceled.
     */
    async stop(element) {
        await Promise.all(element.getAnimations().map((animation) => new Promise(resolve => {
            const handler = this.window.requestAnimationFrame(resolve);
            animation.addEventListener('cancel', () => handler, { once: true });
            animation.addEventListener('finish', () => handler, { once: true });
            animation.cancel();
        })));
    }
    prefersReducedMotion() {
        const query = this.media.match('(prefers-reduced-motion: reduce)');
        return !!query?.matches;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: Animator, deps: [{ token: i1.MediaMatcher }, { token: WINDOW }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: Animator, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: Animator, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1.MediaMatcher }, { type: Window, decorators: [{
                    type: Inject,
                    args: [WINDOW]
                }] }] });

/**
 * Generated bundle index. Do not edit.
 */

export { Animator };
